import React from 'react';
import { motion } from 'framer-motion';
import { Crown, X, Check } from 'lucide-react';
const withoutItems = ['Planillas básicas y genéricas', 'Armás los informes complejos desde cero', 'Sin plantillas premium para obras sociales', 'Formatos limitados y sin actualizaciones'];
const withItems = ['Pack ampliado con planillas premium especializadas', 'Modelos de informes avanzados pre-redactados', 'Plantillas específicas aprobadas por auditorías', 'Acceso a futuras actualizaciones y nuevos formatos'];
export function Guarantee() {
  return <section className="bg-white py-16 px-4 sm:px-6 lg:px-8" data-id="element-105">
      <div className="max-w-xl mx-auto" data-id="element-106">
        {/* Comparison block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-107">
          <span className="inline-flex items-center gap-1.5 bg-brand-tealLight/10 text-brand-tealLight border border-brand-tealLight/30 text-xs font-bold px-3 py-1.5 rounded-full mb-5" data-id="element-108">
            <Crown className="w-3.5 h-3.5" data-id="element-109" /> EXCLUSIVO PACK COMPLETO
          </span>
          <h2 className="text-2xl sm:text-3xl font-bold text-brand-dark mb-3 leading-tight" data-id="element-110">
            Qué vas a obtener con el{' '}
            <span className="text-brand-tealLight" data-id="element-111">PACK COMPLETO</span>
          </h2>
          <p className="text-gray-500 text-[15px]" data-id="element-112">
            La diferencia entre tener planillas básicas y un sistema premium de
            gestión
          </p>
        </motion.div>

        <div className="space-y-4 mb-14" data-id="element-113">
          {/* Sin Pack Completo */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm" data-id="element-114">
            <span className="inline-flex items-center gap-2 bg-gray-100 text-gray-500 text-xs font-bold px-3 py-1.5 rounded-lg mb-4" data-id="element-115">
              <X className="w-3.5 h-3.5" data-id="element-116" /> SI NO TENÉS PACK COMPLETO
            </span>
            <h3 className="text-brand-dark font-bold text-lg mb-4" data-id="element-117">
              Solo tenés el material en PDF
            </h3>
            <ul className="space-y-3" data-id="element-118">
              {withoutItems.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-sm text-gray-600" data-id="element-119">
                  <X className="w-4 h-4 text-gray-400 mt-0.5 flex-shrink-0" data-id="element-120" />
                  <span data-id="element-121">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Con Pack Completo */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="relative bg-brand-dark border-2 border-brand-tealLight rounded-2xl p-6 overflow-hidden" data-id="element-122">
            <div className="absolute top-0 right-0 bg-brand-tealLight/10 w-32 h-32 rounded-full blur-2xl -mr-10 -mt-10 pointer-events-none" data-id="element-123" />
            <div className="flex justify-center mb-4" data-id="element-124">
              <span className="inline-flex items-center gap-1.5 bg-brand-tealLight text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-125">
                <Crown className="w-3.5 h-3.5" data-id="element-126" /> RECOMENDADO
              </span>
            </div>
            <span className="inline-flex items-center gap-2 bg-brand-tealLight/20 text-brand-tealLight text-xs font-bold px-3 py-1.5 rounded-lg mb-4" data-id="element-127">
              <Check className="w-3.5 h-3.5" data-id="element-128" /> SI TENÉS EL PACK COMPLETO
            </span>
            <h3 className="text-white font-bold text-lg mb-4" data-id="element-129">
              Tenés un sistema visual completo
            </h3>
            <ul className="space-y-3 relative z-10" data-id="element-130">
              {withItems.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-sm text-gray-100" data-id="element-131">
                  <Check className="w-4 h-4 text-brand-tealLight mt-0.5 flex-shrink-0" data-id="element-132" />
                  <span data-id="element-133">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        {/* Guarantee */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex flex-col items-center text-center" data-id="element-134">
          <div className="text-5xl mb-6" data-id="element-135">🛡️</div>
          <h2 className="text-2xl font-bold text-brand-dark mb-4" data-id="element-136">
            Garantía 7 días — Sin preguntas
          </h2>
          <p className="text-gray-600 mb-6 text-[15px]" data-id="element-137">
            Abrís el kit. Lo usás. Si en 7 días no es lo que esperabas, te
            devolvemos el 100% sin formularios, sin drama.
          </p>
          <span className="inline-block bg-green-100 text-green-700 border border-green-200 text-sm font-bold px-4 py-1.5 rounded-full" data-id="element-138">
            Tasa de devoluciones: menos del 1%.
          </span>
        </motion.div>
      </div>
    </section>;
}